<div class="claim-overview">
  <div class="sm:hidden mx:block" style="background: white;">
    <customer-select class="customer-selector" style="display: flex; justify-content: end; background: white;
      border-bottom: 1px solid black;"></customer-select>
  </div>
  <div style="margin-top: 30px;">
    <!-- ============ Status step cards ============ -->
    <nz-spin [nzSpinning]="overviewLoading" [nzTip]="'LOADING' | translate">
      <div class="status-cards">
        <ng-container *ngFor="let card of statusCards; let last = last">
          <div class="status-card"
            [class.active]="activeCard === card.key"
            (click)="onStatusCardClick(card.key)"
            (mouseenter)="hoveredCard = card.key"
            (mouseleave)="hoveredCard = null"
            [style.border-left-color]="card.color"
            [style.background-color]="(activeCard === card.key || hoveredCard === card.key) ? hexToRgba(card.color, 0.1) : null">
            <div class="status-card-info">
              <div class="status-card-text" [style.color]="card.color">
                {{ card.label | translate }}
              </div>
              <div class="status-card-count">{{ card.count }}</div>
            </div>
          </div>
          <!-- <div class="status-separator" *ngIf="!last"></div> -->
        </ng-container>
      </div>
    </nz-spin>

    <!-- ============ Filter form ============ -->
    <nz-spin [nzSpinning]="metaLoading" [nzTip]="'LOADING' | translate">
      <div class="filter-form" [formGroup]="searchForm">
        <!-- Row 1: date fields (wider) + 3 dropdowns + 索赔单号 -->
        <div class="filter-row filter-row--equal">

          <div class="filter-field">
            <input class="filter-input" nz-input [placeholder]="'CLAIM_DELIVERY_NO' | translate" formControlName="deliveryNumber" />
          </div>

          <div class="filter-field">
            <input class="filter-input" nz-input [placeholder]="'CLAIM_ORDER_NO' | translate" formControlName="order" />
          </div>

          <div class="filter-field">
            <input class="filter-input" nz-input [placeholder]="'CLAIM_INVOICE_NO' | translate" formControlName="invoice" />
          </div>

          <div class="filter-field">
            <input class="filter-input" nz-input [placeholder]="'MATERIAL_NO' | translate" formControlName="material" />
          </div>

          <div class="filter-field dropdown-field">
            <nz-select class="filter-select" formControlName="status" nzAllowClear [nzPlaceHolder]="'STATUS' | translate"
              [nzSuffixIcon]="dropdownIcon">
              <nz-option *ngFor="let opt of statusOptions" [nzValue]="opt.value" [nzLabel]="opt.label | translate"></nz-option>
            </nz-select>
          </div>

          <!-- 索赔原因 -->
          <div class="filter-field dropdown-field">
            <nz-select class="filter-select" formControlName="reason" nzAllowClear [nzPlaceHolder]="'CLAIM_REASON' | translate"
              [nzSuffixIcon]="dropdownIcon">
              <nz-option *ngFor="let opt of reasonOptions" [nzValue]="opt.value" [nzLabel]="opt.label"></nz-option>
            </nz-select>
          </div>

          <!-- 索赔分类 -->
          <!-- <div class="filter-field dropdown-field">
            <nz-select class="filter-select" formControlName="category" nzAllowClear nzPlaceHolder="索赔分类"
              [nzSuffixIcon]="dropdownIcon">
              <nz-option *ngFor="let opt of categoryOptions" [nzValue]="opt.value" [nzLabel]="opt.label"></nz-option>
            </nz-select>
          </div> -->

          <!-- 索赔方式 -->
          <!-- <div class="filter-field dropdown-field">
            <nz-select class="filter-select" formControlName="claimMethod" nzAllowClear nzPlaceHolder="索赔方式"
              [nzSuffixIcon]="dropdownIcon">
              <nz-option *ngFor="let opt of claimMethodOptions" [nzValue]="opt.value" [nzLabel]="opt.label"></nz-option>
            </nz-select>
          </div> -->
        </div>

        <!-- Row 2: 索赔号 + 日期范围 + 操作按钮 -->
        <div class="filter-row" style="display: grid; grid-template-columns: repeat(6, 1fr); gap: 8px; align-items: flex-end;">

          <div class="filter-field">
            <input class="filter-input" nz-input [placeholder]="'CLAIM_NUMBER' | translate" formControlName="claimNumber" />
          </div>

          <div class="filter-field date-single-field">
            <nz-range-picker class="filter-input" [nzRanges]="translatedRanges" formControlName="dateRange"
              style="width: 100%"></nz-range-picker>
          </div>

          <div class="filter-actions" style="grid-column: 3 / -1; display: flex; align-items: center; gap: 8px;">
            <button class="btn btn-outline" (click)="handleSearch()">
              <i nz-icon nzType="search" nzTheme="outline"></i>
              <span>{{ 'SEARCH' | translate }}</span>
            </button>
            <button class="btn btn-outline" (click)="handleClear()">
              <i nz-icon nzType="delete" nzTheme="outline"></i>
              <span>{{ 'CLEAR' | translate }}</span>
            </button>
            <button class="btn" (click)="handleExport()" [disabled]="exportLoading">
              <svg-icon [iconName]="'new/download.svg'" ></svg-icon>
              <span style="color: #007bc0;">{{ 'EXPORT' | translate }}</span>
            </button>
            <button class="btn btn-primary" (click)="handleCreate()" style="margin-left: auto;">
              <i nz-icon nzType="plus" nzTheme="outline"></i>
              <span>{{ 'CLAIM_CREATE' | translate }}</span>
            </button>
          </div>
        </div>

        <ng-template #dropdownIcon>
          <i nz-icon nzType="caret-down" nzTheme="outline" class="dropdown-caret"></i>
        </ng-template>
      </div>
    </nz-spin>

    <!-- ============ Data table ============ -->
    <nz-spin [nzSpinning]="tableLoading" [nzTip]="'LOADING' | translate">
      <div class="table-wrapper">
        <table class="claim-table">
          <colgroup>
            <col *ngFor="let col of columns" [style.width.px]="col.width" />
          </colgroup>
          <thead>
            <tr>
              <th *ngFor="let col of columns">{{ col.name | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="dataSource.length === 0">
              <td [attr.colspan]="columns.length" style="text-align: center; padding: 40px 0; color: #999;">{{ 'NO_DATA' | translate }}</td>
            </tr>
            <tr *ngFor="let row of dataSource">
              <td>
                <a class="link-cell" (click)="onClaimNumberClick(row)"
                  [attr.title]="row.status === 'DRAFT' ? row.indexNumber : row.claimNumber">{{ row.status === 'DRAFT' ?
                  row.indexNumber : row.claimNumber }}</a>
              </td>
              <td>
                <span [attr.title]="row.customerCode">{{ row.customerCode }}</span>
              </td>
              <!-- Keep the badge free of surrounding whitespace text nodes: a
                   stray space after the inline-flex chip overflows the cell and
                   makes it paint a phantom "…" next to the label. -->
              <td class="status-cell"><span class="status-chip" [style.color]="getStatusColor(row.status).color"
                  [style.background-color]="getStatusColor(row.status).bg">{{ getStatusLabel(row.status) | translate }}</span></td>
              <td [attr.title]="row.reason">{{ row.reason }}</td>
              <td [attr.title]="row.category">{{ row.category }}</td>
              <td [attr.title]="row.scheme">{{ row.scheme }}</td>
              <td [attr.title]="row.createDate">{{ row.createDate }}</td>
              <td>
                <span class="amount-text" [attr.title]="row.amount">{{ row.amount }}</span>
              </td>
              <td class="action-cell">
                <img src="assets/claim/view-detail.png" class="row-action" style="width: 14px; height: 20px;" nz-tooltip [nzTooltipTitle]="'CLAIM_DETAILS' | translate"
                  (click)="openClaimDetails(row)" />
              </td>
              <td class="action-cell">
                <i *ngIf="row.status === 'DRAFT'" nz-icon nzType="edit" nzTheme="outline" class="row-action" nz-tooltip
                  [nzTooltipTitle]="'EDIT' | translate" (click)="onEdit(row)"></i>
                <i nz-icon [nzType]="copyLoading.get(row.id) ? 'loading' : 'copy'" nzTheme="outline" class="row-action" nz-tooltip [nzTooltipTitle]="'CLAIM_COPY' | translate"
                  (click)="onCopy(row)"></i>
                <i *ngIf="row.status === 'DRAFT'" nz-icon nzType="delete" nzTheme="outline" class="row-action"
                  nz-tooltip [nzTooltipTitle]="'DELETE' | translate" nz-popconfirm [nzPopconfirmTitle]="'CLAIM_DELETE_DRAFT_CONFIRM' | translate" [nzOkText]="'DELETE' | translate"
                  [nzCancelText]="'CANCEL' | translate" (nzOnConfirm)="onDelete(row)"></i>
                <i *ngIf="row.status !== 'DRAFT'"
                  nz-icon [nzType]="pdfExportLoading.get(row.id) ? 'loading' : 'file-pdf'" nzTheme="outline"
                  class="row-action" nz-tooltip [nzTooltipTitle]="'CLAIM_EXPORT_PDF' | translate"
                  (click)="exportRowAsPdf(row)"></i>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Pagination -->
        <div class="table-pagination">
          <span class="pagination-total">{{ 'TOTAL_ITEM' | translate: { total: pagination.total } }}</span>
          <nz-select class="page-size-select" [ngModel]="pagination.pageSize" (ngModelChange)="pageSizeChange($event)"
            [nzSuffixIcon]="pageSizeIcon">
            <nz-option *ngFor="let size of pagination.pageSizeOptions" [nzValue]="size"
              [nzLabel]="'CLAIM_ITEM_PER_PAGE' | translate: { size: size }"></nz-option>
          </nz-select>
          <ng-template #pageSizeIcon>
            <i nz-icon nzType="caret-down" nzTheme="outline" class="dropdown-caret"></i>
          </ng-template>

          <nz-pagination class="claim-pagination" [nzPageIndex]="pagination.pageIndex"
            [nzPageSize]="pagination.pageSize" [nzTotal]="pagination.total"
            (nzPageIndexChange)="pageIndexChange($event)"></nz-pagination>
        </div>
      </div>
    </nz-spin>
  </div>

  <!-- ============ Claim details popup (read-only, mirrors create-claim cart popup) ============ -->
  <div class="cart-popup-overlay" *ngIf="detailOpen" (click)="closeClaimDetails()">
    <div class="cart-popup" (click)="$event.stopPropagation()">
      <div class="cart-popup-header">
        <h3 class="cart-popup-title">
          {{ 'CLAIM_DETAILS' | translate }}
          <span class="cart-popup-subtitle" *ngIf="detailClaimNumber">{{ 'CLAIM_DETAIL_CLAIM_NO' | translate: { number: detailClaimNumber } }}</span>
        </h3>
        <i nz-icon nzType="close" nzTheme="outline" class="cart-popup-close" (click)="closeClaimDetails()"></i>
      </div>

      <div class="cart-popup-body">
        <nz-spin [nzSpinning]="detailLoading" [nzTip]="'LOADING' | translate">
          <div class="cart-table-wrapper">
            <nz-table *ngIf="detailItems.length > 0; else emptyDetail" [nzData]="detailItems"
              [nzFrontPagination]="false" [nzShowPagination]="false" [nzScroll]="{ x: 'max-content' }">
              <thead>
                <tr>
                  <th *ngIf="!detailIsOrderMode" nzWidth="90px">{{ 'CLAIM_DETAIL_INVOICE_NO_ITEM' | translate }}</th>
                  <!-- <th *ngIf="!detailIsOrderMode" nzWidth="80px">发票行号</th> -->
                  <th *ngIf="!detailIsOrderMode" nzWidth="120px">{{ 'CLAIM_DETAIL_INVOICE_QTY' | translate }}</th>
                  <th *ngIf="!detailIsOrderMode" nzWidth="180px">{{ 'CLAIM_DETAIL_INVOICE_NET_VALUE' | translate }}</th>
                  <th *ngIf="detailIsOrderMode" nzWidth="90px">{{ 'CLAIM_DETAIL_ORDER_NO_ITEM' | translate }}</th>
                  <!-- <th *ngIf="detailIsOrderMode" nzWidth="80px">订单行号</th> -->
                  <th *ngIf="detailIsOrderMode" nzWidth="120px">{{ 'CLAIM_DETAIL_ORDER_QTY' | translate }}</th>
                  <th *ngIf="detailIsOrderMode" nzWidth="180px">{{ 'CLAIM_DETAIL_ORDER_NET_VALUE' | translate }}</th>
                  <th nzWidth="120px">{{ 'CLAIM_DETAIL_MATERIAL_NO' | translate }}</th>
                  <th *ngIf="detailIsPriceDifferenceMode" nzWidth="180px">{{ 'CLAIM_DETAIL_UNIT_PRICE' | translate }}</th>
                  <th nzWidth="130px" style="text-align: center">{{ 'CLAIM_DETAIL_CLAIM_QTY' | translate }}</th>
                  <th nzWidth="180px">{{ 'CLAIM_DETAIL_CLAIM_NET_VALUE' | translate }}</th>
                  <th nzWidth="100px">{{ 'CLAIM_DETAIL_DELIVERY_NO_ITEM' | translate }}</th>
                  <!-- <th nzWidth="80px">提单行号</th> -->
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of detailItems; let i = index">
                  <td *ngIf="!detailIsOrderMode">{{ item.invoiceNo }}/{{ item.invoiceItemNo }}</td>
                  <!-- <td *ngIf="!detailIsOrderMode">{{ item.invoiceItemNo }}</td> -->
                  <td *ngIf="!detailIsOrderMode">{{ item.dnQuantity }}</td>
                  <td *ngIf="!detailIsOrderMode">{{ item.dnTotalValueWithTax }}</td>
                  <td *ngIf="detailIsOrderMode">{{ item.orderNumber }}/{{ item.orderLineNumber }}</td>
                  <!-- <td *ngIf="detailIsOrderMode">{{ item.orderLineNumber }}</td> -->
                  <td *ngIf="detailIsOrderMode">{{ item.orderQuantity }}</td>
                  <td *ngIf="detailIsOrderMode">{{ item.orderTotalAmount }}</td>
                  <td>{{ item.materialNumber }}</td>
                  <td *ngIf="detailIsPriceDifferenceMode">{{ item.priceDifference }}</td>
                  <td class="qty-cell qty-cell--readonly">{{ item.claimQty }}</td>
                  <td>{{ item.claimAmount }}</td>
                  <td>{{ item.deliveryNumber }}/{{ item.dnItemNo }}</td>
                  <!-- <td>{{ item.dnItemNo }}</td> -->
                </tr>
              </tbody>
            </nz-table>
            <ng-template #emptyDetail>
              <div class="cart-empty">{{ 'CLAIM_DETAIL_EMPTY' | translate }}</div>
            </ng-template>
          </div>
        </nz-spin>
      </div>
    </div>
  </div>
</div>
